import { render } from "./TelehealthAudioEmbedded.vue?vue&type=template&id=d8adf454&scoped=true&ts=true"
import script from "./TelehealthAudioEmbedded.vue?vue&type=script&lang=ts"
export * from "./TelehealthAudioEmbedded.vue?vue&type=script&lang=ts"

import "./TelehealthAudioEmbedded.vue?vue&type=style&index=0&id=d8adf454&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8adf454"]])

export default __exports__